import React from 'react';

import Button from '@core/design-system/button';
import { LPBaseURL, UTMContent } from './enum';
import { generateUTMLink } from './helper';
import { useRouter } from 'next/router';

type WithUTMLinkProps = {
  baseUrl?: LPBaseURL; // Enum para a URL base
  utmContent: UTMContent; // Enum para o conteúdo do UTM
};

function withUTMLink<P extends object>(
  WrappedComponent: React.ComponentType<P>
) {
  const ComponentWithUTMLink: React.FC<P & WithUTMLinkProps> = ({
    baseUrl = LPBaseURL.PRIME,
    utmContent,
    ...props
  }) => {
    const { pathname } = useRouter();
    const link = generateUTMLink({ baseUrl, utmContent, pathname });

    const additionalProps = {
      ...(props as P),
      ...(!props.hasOwnProperty('onClick') &&
        ({ href: link, target: '_blank' } as P)),
    };

    return <WrappedComponent {...additionalProps} />;
  };

  return ComponentWithUTMLink;
}

export const UTMButton: React.FC<any & WithUTMLinkProps> = withUTMLink(Button);
